/* eslint-disable no-nested-ternary */
import moment from 'moment';
import PropTypes from 'prop-types';

import { NumericFormat } from 'react-number-format';
// import MaskedInput from 'react-text-mask';

export const formatPosition = (value, key) => {
  if (value !== null && typeof value === 'object') {
    value = value[key];
  }
  switch (key) {
    case 'fixTime':
    case 'deviceTime':
    case 'serverTime':
      return moment(value).format('LLL');
    case 'latitude':
    case 'longitude':
      return value.toFixed(5);
    case 'speed':
    case 'course':
      return value.toFixed(1);
    case 'batteryLevel':
      return `${value}%`;
    default:
      if (typeof value === 'number') {
        return formatNumber(value);
      }
      if (typeof value === 'boolean') {
        return formatBoolean(value);
      }
      return value;
  }
};

export const formatBoolean = (value) => (value ? 'sharedYes' : 'sharedNo');

export const formatNumber = (value, precision = 1) => Number(value.toFixed(precision));

export const formatDate = (value, format = 'YYYY-MM-DD HH:mm') => moment(value).format(format);

export const formatDistance = (value, unit) => {
  switch (unit) {
    case 'mille':
      return `${(value / 1.609).toFixed(1)} NM`;
    case 'km':
    default:
      return `${value.toFixed(1)} km`;
  }
};

export const formatSpeed = (value, unit) => {
  switch (unit) {
    case 'km/h':
      return `${(value * 1.852).toFixed(0)} ${unit}`;
    case 'nd':
    default:
      return `${value.toFixed(0)} ${unit}`;
  }
};

export const formatAltitude = (value, unit) => {
  switch (unit) {
    case 'ft':
      return `${(value * 3.28084).toFixed(0)} ${unit}`;
    case 'm':
    default:
      return `${value.toFixed(0)} ${unit}`;
  }
};

/* export const TextMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ':', /[0-9]/, /[0-9]/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired
}; */

export function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      isNumericString
      allowLeadingZeros
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export const timeForm = (time) =>
  Math.floor(time / 60) >= 0 && Math.floor(time / 60) <= 9
    ? `000${Math.floor(time / 60)}`
    : Math.floor(time / 60) > 9 && Math.floor(time / 60) < 100
    ? `00${Math.floor(time / 60)}`
    : Math.floor(time / 60) >= 100 && Math.floor(time / 60) < 1000
    ? `0${Math.floor(time / 60)}`
    : `${Math.floor(time / 60)}:${Math.floor(time % 60)}` >= 0 && Math.floor(time % 60) <= 9
    ? 0 + Math.floor(time % 60)
    : Math.floor(time % 60);

export const timeMs = (time) =>
  (Math.round(time.slice(5, 7)) + Math.round(time.slice(0, 4)) * 60) * 60000;

export function decodeHTMLEntities(text) {
  const textArea = document.createElement('textarea');
  textArea.innerHTML = text;
  return textArea.value;
}

export function lastUpdateFormatter(value) {
  let seconds;
  let interval;
  if (value) {
    seconds = Math.floor((new Date() - value) / 1000);
    if (seconds < 0) {
      seconds = 0;
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return `Il y a ${interval} jours`;
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return `Il y a ${interval} heures`;
    }
    return `Il y a ${Math.floor(seconds / 60)} minutes`;
  }
  return null;
}

export function trip(dep, arr) {
  if (dep !== arr) {
    return 'TRIP';
  }
  return null;
}
